export default "__VITE_ASSET__28d297b8__"